import { Location, Title } from "../../../../shared/ui";
import { Link } from "react-router-dom";
import type { FC } from "react";

import styles from "./HotVacancyCard.module.scss";
import { CareerBackInterfacesDTOVacancyVacancyPreviewDto } from "../../../../shared/ApiContract/data-contracts";

interface HotVacancyCardProps extends CareerBackInterfacesDTOVacancyVacancyPreviewDto {
    background?: string;
    to: string;
}

export const HotVacancyCard: FC<HotVacancyCardProps> = ({ name, city, background, to }) => (
    <div className={styles.card} style={{ backgroundImage: `url(${background})` }}>
        <Link to={to} className={styles.card__link}>
            <Title className={styles.card__title} level={3}>
                {name}
            </Title>
        </Link>
        <Location className={styles.location} city={city} />
    </div>
);
